export const ladderFail = () => {
    // @ts-ignore
    const pushLabelSuccess = window.push_label_success as HTMLElement,
    // @ts-ignore
          pushLabelRetry = window.push_label_retry as HTMLElement;
    // @ts-ignore
    (window.push_label_start as HTMLElement).hidden = true;
    pushLabelSuccess.hidden = true;
    pushLabelSuccess.innerText = pushLabelSuccess.innerText.replace(/\d+/, '1');
    pushLabelRetry.hidden = false;
}